import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit_bulk',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].updatePartnerCoupons,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone_bulk',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createPartnerCoupons,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Download CSV',
				id: 'download_csv',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.partnerCoupon,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].getPartnerCoupons,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Create bulk coupons',
			id: 'create_bulk',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.partnerCoupon,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createPartnerCoupons,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
